angular.module("khUtils").factory("SearchTeamFactory", ["$resource", function ($resource) {
    return $resource("/api/team/", {}, {
        query: {
            params: {search: '@searchTerm'}
        }
    });
}]);